import { render, staticRenderFns } from "./SectionImageOrVideo.vue?vue&type=template&id=aadef576&"
import script from "./SectionImageOrVideo.vue?vue&type=script&lang=js&"
export * from "./SectionImageOrVideo.vue?vue&type=script&lang=js&"
import style0 from "./SectionImageOrVideo.vue?vue&type=style&index=0&id=aadef576&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default,OrganismsPortfolioOrganismProjectSlider: require('/app/components/organisms/portfolio/OrganismProjectSlider.vue').default})
